import { objectToParam } from '../../libs/utils';
import axios from '../api';

export async function getUsers(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get('users?' + parameters);
  return data;
}
export async function getUsersForCurrentUser(companyId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`/companies/${companyId}/users?${parameters}`);
  return data;
}

export async function getUser(id) {
  const { data } = await axios.get('users/' + id + '?include=companies');
  return data;
}

export async function getUserPermissions(id) {
  const { data } = await axios.get('users/' + id + '/permissions');
  return data;
}

export async function updateUser(id, values) {
  const { data } = await axios.patch('users/' + id, values);
  return data;
}

export async function deleteUser(id) {
  const { data } = await axios.delete('users/' + id);
  return data;
}

export async function deleteCompanyUser(companyId, userId) {
  const { data } = await axios.delete(`companies/${companyId}/users/${userId}`);
  return data;
}

export async function createUser(values) {
  const { data } = await axios.post('users', values);
  return data;
}

export async function sendPasswordResetMail(id) {
  const { data } = await axios.post(`users/${id}/reset-password`);
  return data;
}

export async function blacklistUser(id, values) {
  const { data } = await axios.post(`users/${id}/blacklist`, values);
  return data;
}

export async function unblacklistUser(id, values) {
  const { data } = await axios.post(`users/${id}/unblacklist`, values);
  return data;
}

// request: {email: string}
// response: { message: string}
export async function requestPasswordResetMail(values) {
  const { data } = await axios.post(`/forgot-password`, values);
  return data;
}

// request: {password: string, password_confirmation: string, email: string, token: string}
// response: { message: string }
export async function resetPassword(values) {
  const { data } = await axios.post(`/reset-password`, values);
  return data;
}

export async function syncUserPermissions(id, permissions) {
  const { data } = await axios.put('users/' + id + '/permissions', permissions);
  return data;
}

export async function syncUserCompanies(id, companies) {
  const { data } = await axios.put('users/' + id + '/companies', companies);
  return data;
}

export async function addUserToCompanyByNRN(companyId, values) {
  const { data } = await axios.post('companies/' + companyId + '/users/add-by-national-registry-number', values);
  return data;
}

export async function impersonateUser(userId) {
  const { data } = await axios.post(`/impersonate/take/${userId}`);
  window.location.href = '/';
  return data;
}
